import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import './CustomTooltip.css';

const CustomTooltip = ({
    children,
    content,
    placement = 'top',
    delay = { show: 200, hide: 100 }
}) => {
    return (
        <OverlayTrigger
            placement={placement}
            delay={delay}
            overlay={props => (
                <Tooltip {...props} className="custom-tooltip">
                    <div className="custom-tooltip-content">
                        {content}
                    </div>
                </Tooltip>
            )}
        >
            {children}
        </OverlayTrigger>
    );
};

export default CustomTooltip;